import { cancelled, delay, spawn } from 'redux-saga/effects'
import { Task } from 'redux-saga'
import connectionsSagas from 'features/connections/state/connectionsSagas'
import mapsSagas from 'features/maps/state/mapsSagas'
import usersSagas from 'features/users/state/usersSagas'
import builderSagas from 'features/builder/state/builderSagas'
import widgetsSagas from 'features/builder/state/WidgetsSagas'
import spatialIndexSagas from 'features/builder/state/spatialIndexSagas'
import accountSagas from 'features/account/state/accountSagas'
import appsSagas from 'features/apps/state/appsSagas'
import developersSagas from 'features/developers/state/developersSagas'
import dataExplorerSagas from 'features/data-explorer/state/dataExplorerSagas'
import dataObservatorySagas from 'features/data-observatory/state/dataObservatorySagas'
import jobsProcessingSagas from 'features/jobs/state/jobsProcessingSagas'
import jobsExportingSagas from 'features/jobs/state/jobsExportingSagas'
import jobsImportingSaga from 'features/jobs/state/jobsImportingSagas'
import hubspotSagas from 'features/hubspot/state/hubspotSagas'
import metricsSagas from 'features/metrics/state/metricsSagas'
import analysisSagas from 'features/analysis/state/analysisSagas'
import onboardingChecklistSagas from 'features/onboarding-checklist/state/onboardingChecklistSagas'
import homeSagas from 'features/home/state/homeSagas'
import popupSagas from 'features/builder/state/popupSagas'
import legendSagas from 'features/builder/state/legendSagas'
import statsSagas from 'features/builder/state/statsSagas'
import queryFiltersSagas from 'features/builder/state/queryFiltersSagas'
import builderCollaborationSagas from 'features/builder/state/collaborationSagas'

const sliceRootSagas = [
  connectionsSagas,
  mapsSagas,
  usersSagas,
  builderSagas,
  widgetsSagas,
  spatialIndexSagas,
  queryFiltersSagas,
  builderCollaborationSagas,
  accountSagas,
  appsSagas,
  developersSagas,
  dataExplorerSagas,
  dataObservatorySagas,
  jobsProcessingSagas,
  jobsExportingSagas,
  jobsImportingSaga,
  hubspotSagas,
  metricsSagas,
  analysisSagas,
  onboardingChecklistSagas,
  homeSagas,
  popupSagas,
  legendSagas,
  statsSagas
]

export default function* rootSaga() {
  const tasks: Task[] = []
  try {
    for (const saga of sliceRootSagas) {
      if (!saga) continue // some sagas are mocked-out to null in tests (?)

      try {
        tasks.push(yield spawn(saga))
      } catch (error) {
        console.error(`failed to spawn slice root saga: ${saga.name}`, error)
      }
    }
    while (true) {
      yield delay(1000000)
    }
  } finally {
    if (yield cancelled()) {
      tasks.forEach((task) => task.cancel())
    }
  }
}
